import { IconFont } from '@/components/IconFont'
import OrbitAvatar from '@/components/OrbitAvatar'
import { selectUser } from '@/store/user/user.slice'
import { Card, Col, Divider, List, Row, Space, Tabs, Typography } from 'antd'
import classnames from 'classnames'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import styles from './index.module.less'
const { TabPane } = Tabs
const { Title, Text, Paragraph } = Typography

export default memo(function Explore() {
  const userInfo = useSelector(selectUser).userInfo!

  return (
    <Row className={styles.container} wrap={false}>
      <Col flex={'350px'} className={classnames('p-3 border-right')}>
        <Space className={'w100'} direction='vertical' align={'center'}>
          <OrbitAvatar avatar={userInfo.avatar} size={88} />
          <span>{userInfo.fullName}</span>
        </Space>

        <Divider />

        <Space direction={'vertical'}>
          <Link to={''}>0 starred Project</Link>
          <Link to={''}>0 starred Libraries</Link>
        </Space>
      </Col>
      <Col flex={'auto'} className={classnames('p-3')}>
        <Row gutter={16}>
          <Col span={16}>
            <Tabs>
              <TabPane tab={'Projects'} key={'projects'}>
                <Title level={4}>Here's what we found based on your interests...</Title>

                <Divider />

                <div>
                  <Card size={'small'} className={'mb-2'}>
                    <div>
                      <OrbitAvatar avatar={'#037C4B'} size={24}></OrbitAvatar>
                      <span> Orbit recommended items</span>
                    </div>

                    <Row className={'mt-2'} wrap={false}>
                      <Col flex={'200px'}>
                        <img
                          width={200}
                          src='https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
                        />
                      </Col>

                      <Col flex={'auto'} className={'ml-2'}>
                        <Title level={5}>
                          <Link to={''}>Cindy Organization / 2-way valve…</Link>
                        </Title>
                        <div className={'mb-2'}>
                          <OrbitAvatar avatar={'#037C4B'} size={24}></OrbitAvatar>
                          <Text type={'secondary'}> Created inApril 08, 2022</Text>
                        </div>

                        <Paragraph>
                          Orbit is a development and run-time environment for cloud-application. It provides a platform
                          on which web-applications can be collaboratively developed and deployed. It allows its
                          developers to focus on the specific business/work processes that they want to achieve, while
                          leaving it to the platform to provide the means and tools to manage comm…
                        </Paragraph>
                      </Col>
                    </Row>
                  </Card>

                  <Card size={'small'} className={'mb-2'}>
                    <div>
                      <OrbitAvatar avatar={'#037C4B'} size={24}></OrbitAvatar>
                      <span> Orbit recommended items</span>
                    </div>

                    <Row className={'mt-2'} wrap={false}>
                      <Col flex={'200px'}>
                        <img
                          width={200}
                          src='https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
                        />
                      </Col>

                      <Col flex={'auto'} className={'ml-2'}>
                        <Title level={5}>
                          <Link to={''}>Cindy Organization / 2-way valve…</Link>
                        </Title>
                        <div className={'mb-2'}>
                          <OrbitAvatar avatar={'#037C4B'} size={24}></OrbitAvatar>
                          <Text type={'secondary'}> Created inApril 08, 2022</Text>
                        </div>

                        <Paragraph>
                          Orbit is a development and run-time environment for cloud-application. It provides a platform
                          on which web-applications can be collaboratively developed and deployed. It allows its
                          developers to focus on the specific business/work processes that they want to achieve, while
                          leaving it to the platform to provide the means and tools to manage comm…
                        </Paragraph>
                      </Col>
                    </Row>
                  </Card>
                </div>
              </TabPane>
              <TabPane tab={'Events'} key={'events'} />
              <TabPane tab={'Jobs'} key={'jobs'} />
            </Tabs>
          </Col>
          <Col span={8}>
            <List
              size='small'
              header={
                <div>
                  <IconFont type='icon-date' className={'mr-1'} style={{ color: '#7B8593' }} />
                  Projects ranking
                </div>
              }
              footer={
                <div>
                  <Link to={''}>See more Projects repositories</Link>
                </div>
              }
              bordered
            >
              <List.Item>
                <div>
                  <div>
                    <IconFont type={'icon-xingzhuang1'} />
                    <Link to={''} className={'ml-1'}>
                      <span>Cindy Organization / </span>
                      <strong>project</strong>
                    </Link>
                  </div>

                  <Text type={'secondary'}>Put the item description here</Text>
                </div>

                <Typography.Text type='secondary'>
                  <IconFont type={'icon-xingxing'} />
                  <span className={'ml-1'}>215</span>
                </Typography.Text>
              </List.Item>

              <List.Item>
                <div>
                  <div>
                    <IconFont type={'icon-xingzhuang1'} />
                    <Link to={''} className={'ml-1'}>
                      <span>Cindy Organization / </span>
                      <strong>project</strong>
                    </Link>
                  </div>

                  <Text type={'secondary'}>Put the item description here</Text>
                </div>

                <Typography.Text type='secondary'>
                  <IconFont type={'icon-xingxing'} />
                  <span className={'ml-1'}>215</span>
                </Typography.Text>
              </List.Item>
            </List>

            <List
              size='small'
              className={'mt-2'}
              header={<div>Libraries ranking</div>}
              footer={
                <div>
                  <Link to={''}>See more Libraries repositories</Link>
                </div>
              }
              bordered
            >
              <List.Item>
                <div>
                  <div>
                    <IconFont type={'icon-xingzhuang1'} />
                    <Link to={''} className={'ml-1'}>
                      <span>Cindy Organization / </span>
                      <strong>2-way</strong>
                    </Link>
                  </div>

                  <Text type={'secondary'}>Put the item description here</Text>
                </div>

                <Typography.Text type='secondary'>
                  <IconFont type={'icon-xingxing'} />
                  <span className={'ml-1'}>215</span>
                </Typography.Text>
              </List.Item>

              <List.Item>
                <div>
                  <div>
                    <IconFont type={'icon-xingzhuang1'} />
                    <Link to={''} className={'ml-1'}>
                      <span>Cindy Organization / </span>
                      <strong>2-way</strong>
                    </Link>
                  </div>

                  <Text type={'secondary'}>Put the item description here</Text>
                </div>

                <Typography.Text type='secondary'>
                  <IconFont type={'icon-xingxing'} />
                  <span className={'ml-1'}>215</span>
                </Typography.Text>
              </List.Item>
            </List>
          </Col>
        </Row>
      </Col>
    </Row>
  )
})
